import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	padding: 0 0 40px;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

class Layout extends React.Component {
	static propTypes = {
	  layoutOptions: PropTypes.array,
	  layout: PropTypes.string,
	  t: PropTypes.func,
	  updatePageSettingsHandler: PropTypes.func,
	}

	static defaultProps = {
	  layout: 'default',
	}

	changeHandler = event => {
	  this.props.updatePageSettingsHandler({
	    layout: event.target.value === '' ? null : event.target.value,
	  })
	}

	render() {
	  const { t, layoutOptions } = this.props;
	  const options = layoutOptions
	    .map(layout => ({
	      value: layout,
	      name: `${t('page/layout_' + layout)}`,
	    }));

	  const blank = [{
	    value: 'default',
	    name: t('brochure/Controls/Page/Default layout'),
	  }];

	  return (
	    <React.Fragment>
	      <Container>
	        <Label>{t('brochure/Controls/Page/Layout')}</Label>
	        <StyledSelect
	          options={blank.concat(options)}
	          id="layout-select"
	          value={this.props.layout || ''}
	          onChange={event => this.changeHandler(event)}
	          style={{ width: '100%' }}
	        />
	      </Container>
	    </React.Fragment>
	  )
	}
}

export default translate('translations')(Layout)
